import { useTonConnectUI, useTonWallet } from "@tonconnect/ui-react";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { ConnectionErrorModal } from "../ConnectionErrorModal";
import Modal from "../Modal/Modal";
import usePlaceARaffleStore from "../PlaceARaffle/usePlaceARaffleStore";

const Modals: React.FC = observer(() => {
  const placeARaffleStore = usePlaceARaffleStore();
  // const unstakeStore = useUnstakeStore();
  // const claimStore = useClaimStore();
  // const claimAndRestakeStore = useClaimAndRestakeStore();
  // const addStakeStore = useAddStakeStore();
  const [connectionErrorModalStatus, setConnectionErrorModalStatus] =
    useState(false);
  const wallet = useTonWallet();
  const [tonConnectUI] = useTonConnectUI();

  useEffect(() => {
    if (!localStorage.getItem("ton-connect-ui_wallet-info")) {
      localStorage.setItem("connectionErrorModalStatus", "false");
      setConnectionErrorModalStatus(false);
      return;
    }

    if (localStorage.getItem("connectionErrorModalStatus") === "true") {
      return;
    }

    if (
      wallet?.device.appName === "telegram-wallet" ||
      wallet?.device.appName === "tonwallet"
    ) {
      localStorage.setItem("connectionErrorModalStatus", "true");
      setConnectionErrorModalStatus(true);
    }
  }, [wallet]);

  useEffect(() => {
    if (!localStorage.getItem("ton-connect-ui_wallet-info")) {
      localStorage.setItem("connectionErrorModalStatus", "false");
      setConnectionErrorModalStatus(false);
      return;
    }

    if (localStorage.getItem("connectionErrorModalStatus") === "true") {
      return;
    }

    if (
      wallet?.device.appName === "telegram-wallet" ||
      wallet?.device.appName === "tonwallet"
    ) {
      localStorage.setItem("connectionErrorModalStatus", "true");
      setConnectionErrorModalStatus(true);
    }
  }, [wallet]);

  useEffect(() => {
    if (wallet?.account.address) {
      placeARaffleStore.fetchHavePassFlow(wallet?.account.address.toString());
    }
  }, [wallet]);

  return (
    <>
      {/* <Claim store={claimStore} />
      <Unstake store={unstakeStore} />
      <ClaimAndRestake store={claimAndRestakeStore} />
      <AddStake store={addStakeStore} /> */}

      <Modal
        small
        isOpened={connectionErrorModalStatus}
        onClose={() => {
          setConnectionErrorModalStatus(false);
          tonConnectUI.disconnect();
        }}
        title="Connection error"
      >
        <ConnectionErrorModal
          onBtnClick={() => {
            setConnectionErrorModalStatus(false);
            tonConnectUI.disconnect();
            tonConnectUI.openModal();
          }}
        />
      </Modal>
    </>
  );
});

export default Modals;
